const decodeToken = (token: string) => {
  const PAYLOAD_INDEX = 1;
  const BASE64_REPLACEMENTS = [
    { search: /-/g, replace: '+' },
    { search: /_/g, replace: '/' },
  ];
  const CHAR_AT_INDEX_ZERO = 0;
  const HEX_BASE = 16;
  const SLICE_START = -2;

  const base64Url = token.split('.')[PAYLOAD_INDEX];
  let base64 = base64Url;
  for (const replacement of BASE64_REPLACEMENTS) {
    base64 = base64.replace(replacement.search, replacement.replace);
  }

  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(CHAR_AT_INDEX_ZERO).toString(HEX_BASE)).slice(SLICE_START))
      .join(''),
  );

  return JSON.parse(jsonPayload) as unknown;
};

export default decodeToken;
